import { getItem, setItem } from '@/utils';
import { login, refresh } from '@/api';

const ACCESS_TOKEN_KEY = 'comics_v1_t_k';

export function getAccessToken() {
  return getItem(ACCESS_TOKEN_KEY);
}

export default async function AppLogin() {
  const res = await login();
  if (res.code === 0) {
    setItem(ACCESS_TOKEN_KEY, res?.data?.access_token || '');
  }
}

export async function RefreshLoginStatus() {
  const res = await refresh();
  if (res.code === 0) {
    setItem(ACCESS_TOKEN_KEY, res?.data?.access_token || '');
  }
}
